import { render, staticRenderFns } from "./MergeArtistsModal.vue?vue&type=template&id=625a7278&scoped=true&"
import script from "./MergeArtistsModal.vue?vue&type=script&lang=js&"
export * from "./MergeArtistsModal.vue?vue&type=script&lang=js&"
import style0 from "./MergeArtistsModal.vue?vue&type=style&index=0&id=625a7278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a7278",
  null
  
)

export default component.exports